export default "__VITE_ASSET__D5mX0N$G__"